// extracted by mini-css-extract-plugin
export var footer = "_or-0";
export var inherit = "_or-1";
export var input = "_or-2";
export var modalContent = "_or-3";
export var quillEditor = "_or-4";
export var subtitle = "_or-5";